import { ServiceUrlsProvider } from '@ori/configuration-manager';
import { EnvironmentProvider } from '@ori/environment';
import { FavoritesProvider } from '@ori/favorites-heart';
import { TranslationsProvider } from '@ori/i18n';
import { ProductInfoDialogController } from '@ori/product-info-dialog';
import { Team, TestIdProvider } from '@ori/testid-generator';
import { APP_NAME } from './constants-generated';
import { jsx as _jsx } from "react/jsx-runtime";
export const App = ({
  currentLanguage,
  globalApiUrl = '',
  graphqlUrl,
  graphqlNetUrl,
  staticApiUrl = '',
  tenant
}) => /*#__PURE__*/_jsx(TestIdProvider, {
  team: Team.Presentation,
  project: APP_NAME,
  children: /*#__PURE__*/_jsx(ServiceUrlsProvider, {
    serviceUrls: {
      globalApiUrl,
      graphQlUrl: graphqlUrl,
      graphQlNetUrl: graphqlNetUrl,
      staticApiUrl
    },
    children: /*#__PURE__*/_jsx(EnvironmentProvider, {
      tenant: tenant,
      children: /*#__PURE__*/_jsx(TranslationsProvider, {
        defaultTranslationsWithNamespaces: {},
        language: currentLanguage,
        translationsWithNamespaces: {},
        children: /*#__PURE__*/_jsx(FavoritesProvider, {
          children: /*#__PURE__*/_jsx(ProductInfoDialogController, {})
        })
      })
    })
  })
});